export const cityConstants = {
  GETALL_CITIES_REQUEST: 'CITIES_GETALL_REQUEST',
  GETALL_CITIES_SUCCESS: 'CITIES_GETALL_SUCCESS',
  GETALL_CITIES_FAILURE: 'CITIES_GETALL_FAILURE',

  GETALL_PROVINCES_REQUEST: 'PROVINCES_GETALL_REQUEST',
  GETALL_PROVINCES_SUCCESS: 'PROVINCES_GETALL_SUCCESS',
  GETALL_PROVINCES_FAILURE: 'PROVINCES_GETALL_FAILURE'
}